import { render, staticRenderFns } from "./homeStudy.vue?vue&type=template&id=eddf479a&scoped=true&"
import script from "./homeStudy.vue?vue&type=script&lang=js&"
export * from "./homeStudy.vue?vue&type=script&lang=js&"
import style0 from "./homeStudy.vue?vue&type=style&index=0&id=eddf479a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddf479a",
  null
  
)

export default component.exports